module.exports = __webpack_public_path__ + "img/icon-download.3a1eb315.svg";